import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M26.19 14.84a.773.773 0 0 0 1.169-1.013L26.19 14.84ZM15.81 27.16a.773.773 0 0 0-1.169 1.013l1.168-1.013Zm5.963-17.271a.773.773 0 1 0-1.546 0h1.546ZM20.227 32.11a.773.773 0 1 0 1.546 0h-1.546Zm20-11.111c0 10.619-8.608 19.227-19.227 19.227v1.546c11.473 0 20.773-9.3 20.773-20.773h-1.546ZM21 40.227C10.381 40.227 1.773 31.619 1.773 21H.227c0 11.473 9.3 20.773 20.773 20.773v-1.546ZM1.773 21C1.773 10.381 10.381 1.773 21 1.773V.227C9.527.227.227 9.527.227 21h1.546ZM21 1.773c10.619 0 19.227 8.608 19.227 19.227h1.546C41.773 9.527 32.473.227 21 .227v1.546Zm0 18.454c-1.71 0-3.222-.463-4.285-1.172-1.069-.712-1.609-1.611-1.609-2.5H13.56c0 1.567.952 2.89 2.297 3.787 1.35.9 3.17 1.431 5.143 1.431v-1.546Zm-5.894-3.671c0-.889.54-1.788 1.609-2.5 1.063-.708 2.575-1.172 4.285-1.172v-1.546c-1.972 0-3.793.532-5.143 1.432-1.345.896-2.297 2.22-2.297 3.786h1.546ZM21 12.884c2.308 0 4.223.84 5.19 1.956l1.169-1.013c-1.337-1.541-3.732-2.489-6.359-2.489v1.546Zm0 8.889c1.71 0 3.222.463 4.285 1.172 1.069.712 1.609 1.611 1.609 2.5h1.546c0-1.567-.953-2.89-2.297-3.787-1.35-.9-3.17-1.431-5.143-1.431v1.546Zm-.773-11.884v2.222h1.546V9.89h-1.546Zm0 20v2.222h1.546V29.89h-1.546Zm.773-.773c-2.308 0-4.223-.84-5.19-1.956l-1.169 1.013c1.337 1.541 3.732 2.489 6.359 2.489v-1.546Zm5.894-3.672c0 .889-.54 1.788-1.609 2.5-1.063.709-2.575 1.172-4.285 1.172v1.546c1.972 0 3.793-.532 5.143-1.432 1.345-.896 2.297-2.22 2.297-3.786h-1.546Zm-6.667-13.333V29.89h1.546V12.11h-1.546Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
